// Import des scripts des composants
import { initAlert } from './components/alert/alert.js';
import { initToggleTheme } from './components/toggle-theme/toggle-theme.js';
import { initShapeSwitcher } from './components/shape-switcher/shape-switcher.js';
import { initTooltips } from './components/tooltip/tooltip.js';
import { initTabs } from './components/tabs/tabs.js';
import { initAccordion } from './components/accordion/accordion.js';
import { initDropdowns } from './components/dropdown/dropdown.js';
import { initMenu } from './components/menu/menu.js';
import { initToc } from './components/toc/toc.js';
import { initStt } from './components/scroll-to-top/scroll-to-top.js';
import { initDrawer } from './templates/drawer/drawer-layout.js';
import { initSelectAllCheckbox } from './components/checkbox/checkbox.js';
import { initInputs } from './components/input/input.js';
import { initDateFields } from './components/date-field/date-field.js';
import { initColorFields } from './components/color-field/color-field.js';
import { initTextareas } from './components/textarea/textarea.js';
import { initSelects } from './components/select/select.js';
import { initFileInputs } from './components/upload/upload.js';
import { initModal } from './components/modal/modal.js';
import { initPopover } from './components/popover/popover.js';
import { initPagination } from './components/pagination/pagination.js';
import { initSkipLinks } from './components/skip-links/skip-links.js';
import { initToast } from './components/toast/toast.js';
import { initTour } from './components/tour/tour.js';
import { initAvatar } from './components/avatar/avatar.js';
import { initProgress } from './components/progress/progress.js';
import { initSteps } from './components/steps/steps.js';
import { initFilter } from './components/filter/filter.js';
import { initAuthRandomImage } from './pages/auth-pages/auth-pages.js';
// Command Palette : exporté mais non initialisé automatiquement
// Permet aux projets de l'activer manuellement avec window.CommandPalette.init()
import './components/command-palette/command-palette.js';


// Appel unique pour initialiser tous les composants sur la page
initComponents();

// Fonction globale pour contenu dynamique
export function initComponents(container = document) {
  initAlert(container);
  initTooltips(container);
  initTabs(container);
  initAccordion(container);
  initMenu(container);
  initDropdowns(container);
  initToc(container);
  initToggleTheme(container);
  initStt(container);
  initDrawer(container);
  initSelectAllCheckbox(container);
  initInputs(container);
  initDateFields(container);
  initColorFields(container);
  initTextareas(container);
  initSelects(container);
  initShapeSwitcher(container); // après initSelects (variante select-custom)
  initFileInputs(container);
  initModal(container);
  initPopover(container);
  initPagination(container);
  initSkipLinks(container);
  initToast(container);
  initTour();
  initAvatar(container);
  initProgress(container);
  initSteps(container);
  initFilter(container);
  initAuthRandomImage(container);
}

// Exposer la fonction globalement
window.initComponents = initComponents;

